import API from 'services/api';
import { fetchWithRetry } from 'services/fetchWithRetry';

class EpcisService {
    private readonly getEpcisURL = `/epcis`;
    private readonly epcisXmlByIdURL = `/compliance/epcis/id`;
    // ---------------------------------------------------------------

    downloadEpcisXmlById(epcisId: number, version: '1.0' | '1.2' | '2.0') {
        return fetchWithRetry(
            API.get(`${this.epcisXmlByIdURL}/${epcisId}/xml`, {
                params: { version },
                responseType: 'blob',
            })
        );
    }

    downloadEpcisJsonById(epcisId: number, version: '2.0' = '2.0') {
        return fetchWithRetry(
            API.get(`${this.epcisXmlByIdURL}/${epcisId}/json`, {
                params: { version },
                responseType: 'blob',
            })
        );
    }

    getEpcis(params: {
        size: number;
        page: number;
        email: string;
        ndcCode: string;
        lotNumber: string;
        itemName: string;
        expiredOnly: boolean;
        startDate: string;
        endDate: string
    }) {
        return fetchWithRetry(API.get(this.getEpcisURL, { params }));
    }

    voidShipping(epcisId: number, originalShippingEventId: string, epcUrn: string) {
        return fetchWithRetry(
            API.post(`/admin/epcis/${epcisId}/void-shipping`, {
                originalShippingEventId,
                epcUrn,
            })
        );
    }

    getOutboundValidation(epcisId: number) {
        return fetchWithRetry(API.get(`/admin/epcis/${epcisId}/validation`));
    }

    partialVoidShipping(epcisId: number, originalShippingEventId: string, epcUrns: string[]) {
        return fetchWithRetry(
            API.post(`/admin/epcis/${epcisId}/partial-void-shipping`, {
                originalShippingEventId,
                epcUrns,
            })
        );
    }
}

export default new EpcisService();
